<template>
  <Modal
    width="1120"
    v-model="state"
    :title="title"
    :closable="false"
    :mask-closable="false"
    class-name="c-manage vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <!-- <Spin size="large" fix v-if="loading" /> -->
    <Row class="filter-box" :gutter="12" v-if="state">
      <Col span="24">
        <Form :label-width="50" inline>
          <drop-autoComplete label="创建人" member :default-option="defaultOpenId" @on-change="changeOperator" />
          <drop-autoComplete label="游戏" game @on-change="changeGame" />
          <drop-autoComplete label="游戏组" group @on-change="changeGroup" />
          <FormItem label="平台">
            <Select v-model="platform">
              <Option :value="-1" disabled>全部</Option>
              <Option :value="1" disabled>Android</Option>
              <Option :value="2" disabled>iOS</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="20">
            <Input v-model="keyword" placeholder="请输入策略名称或ID" search />
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table
          ref="table"
          height="360"
          stripe
          :loading="loading"
          :columns="columns"
          :data="data"
          @on-row-click="rowClick"
          @on-select="selectRow"
          @on-select-all="selectAll"
          @on-select-cancel="cancelRow"
          @on-select-all-cancel="cancelAll"
        >
          <template slot-scope="{ row }" slot="createTime">
            <span>{{ row.createTime | datetimeToSec }}</span>
          </template>
        </Table>
        <Page show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" class="page-index" />
      </Col>
    </Row>
    <Row slot="footer" :gutter="12">
      <Button type="default" @click="$emit('on-cancel')">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { debounce, trim } from '@/common/js/utils'
import columns from './columns.json'
import DropAutoComplete from '@/components/dropdown/'

export default {
  name: 'PolicyManage',
  components: { DropAutoComplete },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    platform: {
      type: Number
    },
    media: {
      type: [Number, String]
    },
    openId: {
      type: [Number, String]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.defaultData.length
    },
    title() {
      return `策略模板选择  ${this.len ? '(已选' + this.len + '条)' : ''}`
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.opId = ''
        this.gameId = ''
        this.keyword = ''
        this.pageIndex = 1
        this.defaultData = []
        this.setOpenId()
      }
    },
    sendEvent() {
      const keyword = trim(this.keyword)
      this.$emit('on-change', {
        keyword: keyword === '' ? undefined : keyword,
        platform: this.platform === -1 ? undefined : this.platform,
        opId: this.opId,
        gameId: this.gameId,
        gameGroupId: this.groupId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      })
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-policy')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.sendEvent()
    },
    changeOperator(meta) {
      this.pageIndex = 1
      this.opId = meta.id
    },
    changeGame(meta) {
      this.pageIndex = 1
      this.gameId = meta.id
    },
    changeGroup(meta) {
      this.pageIndex = 1
      this.groupId = meta.id
    },
    rowClick(data, index) {
      this.$refs.table.toggleSelect(index)
    },
    selectRow(selection, row) {
      this.defaultData.push(row)
    },
    selectAll() {
      this.data.forEach((ret) => {
        this.selectRow([], ret)
      })
    },
    cancelRow(selection, row) {
      const index = this.defaultData.findIndex((ret) => ret.id === row.id)
      if (index > -1) this.defaultData.splice(index, 1)
    },
    cancelAll() {
      this.data.forEach((ret) => {
        this.cancelRow([], ret)
      })
    },
    save() {
      if (this.defaultData.length) {
        this.setOperatorStorage('select-policy', this.opId || -1) // 记录上次成功opId
        this.$emit('on-select', this.defaultData)
      } else this.$Message.warning('您未选择一个策略模板')
    }
  },
  data() {
    return {
      opId: '',
      gameId: '',
      groupId: '',
      keyword: '',
      pageIndex: 1,
      pageSize: 10,
      columns: columns,
      defaultData: [],
      defaultOpenId: ''
    }
  },
  watch: {
    opId() {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    gameId() {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    keyword() {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    platform() {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    groupId() {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    }
  },
  created() {
    this.setOpenId()
  }
}
</script>
<style lang="scss" scoped>
.c-manage {
  position: relative;

  .filter-box {
    margin-bottom: 15px;

    ::v-deep .ivu-form-item {
      margin-bottom: 0;
    }
  }

  .page-index {
    margin-top: 12px;
    text-align: right;
  }

  .block-span {
    display: inline-block;
  }
}
</style>
